import LinkedSidebarContent from "./LinkedSidebarContent";

import "./styles.scss";

export default function AllDetails({ detectionDetails }) {
  const { files, processes } = detectionDetails;

  const sections = [
    { id: "files", title: "Files", items: files || [], titleKeyword: "file" },
    { id: "processes", title: "Processes", items: processes || [], titleKeyword: "process" },
    // { id: "hashes", title: "Hashes", items: hashes || [] },
  ];

  return (
    <div>
      <LinkedSidebarContent
        sections={sections}
        defaultActiveSectionTitle="File"
        defaultActiveTabId="details"
        loading={false}
        error={false}
      />
    </div>
  );
}
